import { TCustomIcons } from './interfaces';
import { FC, SVGProps } from 'react';
import {
  AmericanExpress,
  Arrow,
  DinersClub,
  Discover,
  Jsb,
  Maestro,
  MasterCard,
  Mir,
  NoNameCard,
  Pro100,
  RotateLeft,
  RotateRight,
  UnionPay,
  Visa,
} from './icons';

export const CUSTOM_ICONS_MAP: Map<TCustomIcons, FC<SVGProps<SVGSVGElement>>> = new Map<
  TCustomIcons,
  FC<SVGProps<SVGSVGElement>>
>([
  ['american-express', AmericanExpress],
  ['diners-club', DinersClub],
  ['discover', Discover],
  ['jcb', Jsb],
  ['maestro', Maestro],
  ['mastercard', MasterCard],
  ['mir', Mir],
  ['pro100', Pro100],
  ['unionpay', UnionPay],
  ['visa', Visa],
  ['no-name-card', NoNameCard],
  ['arrow', Arrow],
  ['rotate-right', RotateRight],
  ['rotate-left', RotateLeft],
]);
